import { useParams } from "react-router-dom";
import { useQueryClient } from "react-query";
import moment from "moment";
import { txt } from "../../../services/translation";

export default function useIsLocked(){

    const {course, tab} = useParams();

    const queryClient = useQueryClient();

    const data = queryClient.getQueryData(course);

    const sections = data.chapters.reduce((a,b) => a.concat(b.sections), []);
    
    const section = sections.find(s => s.id === tab);

    if(!section) return [false, '', null];

    /** Chapter not released yet for the session the learner belongs to */
    const unlockAt = section.chapter?.unlockAt;

    if(unlockAt && moment(unlockAt).valueOf() > moment().valueOf()){
        return [
            true,
            `Ce chapitre sera débloqué le ${moment(unlockAt).format('DD/MM/YYYY')}.`,
            'info'
        ];
    }

    /** Section locked because of uncompleted required section */
    let i = 0;

    while(i < sections.length){

        let previousSection = sections[i];

        if(previousSection.id === tab) break;

        if(previousSection.required && !previousSection.completed){

            return [
                true, 
                txt('completePreviousSection', { section: previousSection.title }), 
                'warning'
            ];
        }

        i++;
    }

    /** Section locked because EPP 2 did not started */
    if(section.epp2){
        const u3Start = moment(data.dpcSession?.u3Start);
        if( u3Start.valueOf() > moment().valueOf() ){
            return [
                true, 
                `Ce chapitre correspond à l'unité 3 de votre session DPC. Il sera débloqué le ${u3Start.format('DD/MM/YYYY')}.`,
                'info'
            ];
        }
    }

    return [false, ''];

}